/**
 * Shared section constants and helpers for analysis sections.
 * Used by Review, AnalysisCompare, and RankingDashboard.
 */

export const KNOWN_SECTIONS = ['media_metadata', 'image_details', 'enrichment_hint'];

export const SECTION_LABELS = {
  core: 'Core Fields',
  media_metadata: 'Media Metadata',
  image_details: 'Image Details',
  enrichment_hint: 'Enrichment Hint',
  raw: 'Raw JSON',
};

export function formatSectionLabel(key) {
  if (!key) return 'Unknown';
  return SECTION_LABELS[key] || key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
